import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { Location, LocationParams } from 'lib/componentLocation';

import { RowExpansionMode } from 'portcall/gridcomponents/model';

import { PendingExports, PendingExportsParams } from './pendingexports';
import { PendingExportsView } from './pendingexportsview';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';

export function PendingExportsRoute(
    model : (params : PendingExportsParams) => PendingExports,
    appWrapper : AppWrapper,
    request : Location
) : IRoute {
    const m = model(inboundParams(request));

    return {
        view:
            <AppWrapperView model={appWrapper}>
                <PendingExportsView model={m} />
            </AppWrapperView>,
        reflectState: () => outboundParams(request, m)
    };
}

function inboundParams(request : Location) : PendingExportsParams {
    const id = +(request.params['id'] || 0),
        expansionMode = request.params['expansion'],
        filter = request.params['filter'];

    return {
        id,
        expansionMode: expansionMode !== undefined ? +expansionMode : RowExpansionMode.AutoCollapse,
        filter
    };
}

function outboundParams(request : Location, m : PendingExports) {
    const params = {} as LocationParams;
    params['id'] = m.Model.Id() + '';
    if (m.RowExpander.ExpansionMode() !== RowExpansionMode.AutoCollapse)
        params['expansion'] = m.RowExpander.ExpansionMode() + '';
    if (m.Filter()) params['filter'] = m.Filter();
    return new Location(request.name, params);
}



// WEBPACK FOOTER //
// ./apps/portcall/quickbooksexports/pendingexportsroute.tsx